import apiClient from '../api-client';

export const getAllTags = () => apiClient.get('/file-explorer/tag').then(res => res.data);

export const getDirectoryTree = (path, depth, queryString, tagIds) => apiClient.get('/file-explorer/search', {
    params: {
        path: path,
        depth: depth,
        is_directory_only: 1,
        q: queryString,
        tags: tagIds,
        to: 150,
    }
}).then(res => res.data);

export const getDirectoryContent = (path, queryString, tagIds, page, pageSize, sortedField, sortedDirection) => apiClient.get('/file-explorer/search', {
    params: {
        path: path,
        depth: 1,
        is_directory_only: 0,
        q: queryString,
        tags: tagIds,
        from: page * pageSize,
        to: (page + 1) * pageSize,
        sorted_field: sortedField,
        sorted_direction: sortedDirection,
    }
}).then(res => res.data);

export const createNewSharingUrl = (fileSystemNodePath, expirationTimeQuantity, expirationTimeUnit, cancelToken) => apiClient.put('/resource/shared-resource-accessor/' + fileSystemNodePath.join('/'), {
    expiration_time_quantity: expirationTimeQuantity,
    expiration_time_unit: expirationTimeUnit,
},{
    cancelToken: cancelToken,
}).then(res => res.data);

export const downloadResource = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.click();
    link.remove();
};

export const createNewDirectory = (fileSystemNodePath, name, cancelToken) => apiClient.post('/resource/' + fileSystemNodePath.concat([name]).join('/'), {},{
    cancelToken: cancelToken,
}).then(res => res.data);

export const deleteFileSystemNode = (fileSystemNodePath, cancelToken) => apiClient.delete('/resource/' + fileSystemNodePath.join('/'), {},{
    cancelToken: cancelToken,
}).then(res => res.data);


export const renameFileSystemNode = (fileSystemNodePath, name, cancelToken) => apiClient.put('/resource/' + fileSystemNodePath.join('/'), {
    name: name,
},{
    cancelToken: cancelToken,
}).then(res => res.data);

export const updateFileSystemNodeTags = (fileSystemNodePath, tags, cancelToken) => apiClient.put('/resource/' + fileSystemNodePath.join('/'), {
    tags: tags,
},{
    cancelToken: cancelToken,
}).then(res => res.data);